<template>
  <div style="min-height: 80vh">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-layout justify-center wrap v-if="privacy" pa-3 pa-sm-16>
      <v-flex xs12 align-self-center text-left style="color:black" pa-md-16>
        <span v-html="privacy.privacyPolicy"> </span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      privacy: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/hackathon/static/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.privacy = response.data.data;
            // console.log(this.privacy.privacyPolicy);
            this.msg = response.data.msg;
            // this.showSnackBar = true;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            // this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
